import t from 'react-translate';

import { MentoringProgramRole } from 'redux/schemas/models/mentoring-program-enrollments';
import { SingleMentorRequestStatus } from 'redux/schemas/models/mentor-request';

import { useMentorRequestContext } from '../mentor-request-context';

const MentorRequestHeader = () => {
  const { request, participant, aliases, role } = useMentorRequestContext();
  const isMentor = role === MentoringProgramRole.MENTORSHIP_PROGRAM_MENTOR;
  let header = isMentor
    ? t.MENTORING_PROGRAMS.PARTICIPANT_HOME.MENTOR_REQUEST_MODAL.MENTOR_VIEW.TITLE({
      menteeName: participant.user.firstName,
      mentorAlias: aliases.mentor.downcasedSingularized,
    }) : t.MENTORING_PROGRAMS.PARTICIPANT_HOME.MENTOR_REQUEST_MODAL.MENTEE_VIEW.TITLE({
      mentorName: participant.user.firstName,
      MentorAlias: aliases.mentor.capitalizedSingularized,
    });

  if (request && request.state === SingleMentorRequestStatus.PENDING && !isMentor) {
    header = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.MENTOR_REQUEST_MODAL.MENTEE_VIEW.PENDING_REQUEST_TITLE();
  }

  return (
    <div className='heading-2 mb-5'>
      {header}
    </div>
  );
};

export default MentorRequestHeader;
